"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoyaltyAccountDataResponseToJSON = exports.LoyaltyAccountDataResponseFromJSONTyped = exports.LoyaltyAccountDataResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function LoyaltyAccountDataResponseFromJSON(json) {
    return LoyaltyAccountDataResponseFromJSONTyped(json, false);
}
exports.LoyaltyAccountDataResponseFromJSON = LoyaltyAccountDataResponseFromJSON;
function LoyaltyAccountDataResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'mainCardNumber': json['mainCardNumber'],
        'totalPointsAmount': json['totalPointsAmount'],
        'serviceConsentStatus': (0, _1.LoyaltyEntitlementStatusFromJSON)(json['serviceConsentStatus']),
        'marketingConsentStatus': (0, _1.LoyaltyEntitlementStatusFromJSON)(json['marketingConsentStatus']),
        'errors': !(0, runtime_1.exists)(json, 'errors') ? undefined : (0, _1.MessagesFromJSON)(json['errors']),
        'warnings': !(0, runtime_1.exists)(json, 'warnings') ? undefined : (0, _1.MessagesFromJSON)(json['warnings']),
    };
}
exports.LoyaltyAccountDataResponseFromJSONTyped = LoyaltyAccountDataResponseFromJSONTyped;
function LoyaltyAccountDataResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'mainCardNumber': value.mainCardNumber,
        'totalPointsAmount': value.totalPointsAmount,
        'serviceConsentStatus': (0, _1.LoyaltyEntitlementStatusToJSON)(value.serviceConsentStatus),
        'marketingConsentStatus': (0, _1.LoyaltyEntitlementStatusToJSON)(value.marketingConsentStatus),
        'errors': (0, _1.MessagesToJSON)(value.errors),
        'warnings': (0, _1.MessagesToJSON)(value.warnings),
    };
}
exports.LoyaltyAccountDataResponseToJSON = LoyaltyAccountDataResponseToJSON;
//# sourceMappingURL=LoyaltyAccountDataResponse.js.map